<template>
  <div :class="$style.preface">
    <p>
      厦门极致互动网络技术股份有限公司（以下简称“
      极致游戏”）按照下列条款与条件在本网站上提供信息和产品。
    </p>
    <p>
      访问本网站时，表示您同意这些条款与条件。
      极致游戏保留无需通知即可随时根据具体情况自行更改这些条款和条件，以及本网站所提及的产品、服务、价格与程序的权利。若您不同意下列条款与条件，请您立即关闭并停止访问本网站。
    </p>
    <p>
      若您违反下列条款与条件，则 极致游戏
      保留权利，可以诉诸法律寻求补偿。极致游戏保留一切未在此明示授予的权利。
    </p>
  </div>
</template>

<script>
export default {}
</script>

<style lang="less" module>
.preface {
  position: relative;
  margin: 0 3.6rem;
  padding: 0.76rem 0.89rem 0.76rem 5.42rem;
  border-radius: 0.1rem;
  background: #f5f6fb;
  box-sizing: border-box;

  p {
    z-index: 1;
    position: relative;
    line-height: 1.6;

    &:not(:first-child) {
      margin-top: 1.6em;
    }
  }

  &::before {
    .size(0.33rem, 0.3rem);
    content: '';
    position: absolute;
    top: -0.15rem;
    left: 5.42rem;
    background: url('./images/protocol-preface-badge.png') no-repeat;
    background-size: 100% 100%;
  }

  &::after {
    .size(9.18rem, 6.01rem);
    content: '';
    position: absolute;
    left: -0.63rem;
    bottom: -1.82rem;
    background: url('./images/protocol-preface-illus.png') no-repeat;
    background-size: 100% 100%;
  }

  @media screen and (max-width: @tablet-width) {
    margin: 0 2rem;
  }

  @media screen and (max-width: @mini-width) {
    margin: 0 1rem;
    padding: 1rem;
    font-size: 12px;

    &::before,
    &::after {
      content: none;
    }

    p {
      &:not(:first-child) {
        margin-top: 1em;
      }
    }
  }
}
</style>
